"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GuestEvent = void 0;
var GuestEvent;
(function (GuestEvent) {
    GuestEvent["getReservationRequestAnswer"] = "getReservationRequestAnswer";
    GuestEvent["notifyGuest"] = "notifyGuest";
})(GuestEvent || (exports.GuestEvent = GuestEvent = {}));
//# sourceMappingURL=GuestEvent.js.map